import Vue from "vue";

Vue.prototype.$notifySuccess = (text = "Дані збережено") => {
  Vue.notify({ text, type: "success" });
};

Vue.prototype.$notifyWarning = (text = "Обов'язкові поля не заповнені") => {
  Vue.notify({ text, type: "warning" });
};